export enum ANNOUNCEMENT_CATEGORY {
  schedule = 'schedule',
  businessNoticeId = 'business',
  contractAlmostExpire = 'contract-almost-expire',
  dailyWork = 'daily-work',
}
